import React, { useState } from 'react';
import { AppBar, Toolbar, IconButton, Drawer, List, ListItem, ListItemText, Typography, Box, useMediaQuery } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import './ResponsiveMenu.css';

const ResponsiveMenu = ({ scrollToSection, sectionRefs }) => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const isMobile = useMediaQuery('(max-width:600px)');

  const toggleDrawer = (open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    setIsDrawerOpen(open);
  };

  const menuItems = [
    { label: 'Home', ref: sectionRefs.welcomeRef },
    { label: 'Our Story', ref: sectionRefs.ourStoryRef },
    { label: 'Program', ref: sectionRefs.programRef },
    { label: 'Venue', ref: sectionRefs.venueRef }
  ];

  return (
    <AppBar position="static" className="app-bar">
      <Toolbar className="toolbar">
        <Typography variant="h6" className="title">
          NiranChan
        </Typography>
        {isMobile ? (
          <>
            <IconButton edge="end" color="inherit" onClick={toggleDrawer(true)} aria-label="menu">
              <MenuIcon className='menu-icon'/>
            </IconButton>
            <Drawer anchor="right" open={isDrawerOpen} onClose={toggleDrawer(false)} className='drawer'>
              <Box role="presentation" onClick={toggleDrawer(false)} onKeyDown={toggleDrawer(false)}>
                <List className="drawer-list">
                  {menuItems.map((item, index) => (
                    <ListItem button key={index} onClick={() => { scrollToSection(item.ref); setIsDrawerOpen(false); }}>
                      <ListItemText className='drawer-list-item' primary={item.label}/>
                    </ListItem>
                  ))}
                </List>
              </Box>
            </Drawer>
          </>
        ) : (
          <Box className="menu-items">
            {menuItems.map((item, index) => (
              <Typography variant="button" className="menu-item" key={index} onClick={() => scrollToSection(item.ref)}>
                {item.label}
              </Typography>
            ))}
          </Box>
        )}
      </Toolbar>
    </AppBar>
  );
};

export default ResponsiveMenu;
